import { AngularFirestoreCollection } from "@angular/fire/firestore"

import { FirebaseService } from "./firebase.service"

export interface FirebaseResource {
  _id?: string
}

export abstract class ResourceBase<T extends FirebaseResource> {
  public abstract getCollection(...params: any[]): AngularFirestoreCollection

  public data: T[] = []
  public dataMap: { [id: string]: T } = {}

  constructor(
    protected firebaseService: FirebaseService,
  ) {}

  public getId(item: T): string {
    return item._id
  }

  public setId(item: T, newId: string): void {
    item._id = newId
  }

  public mapDataItem(dataItem: any): T {
    return dataItem
  }

  public async getData(company: string): Promise<T[]> {
    const collectionSnapshot = await this.getCollection(company)
      .ref.get()

    this.data = collectionSnapshot.empty
      ? []
      : collectionSnapshot.docs.map<T>(snapshot => {
        if (!snapshot.exists) {
          return null
        }

        const data = snapshot.data() as T
        this.setId(data, snapshot.id)
        this.dataMap[this.getId(data)] = this.mapDataItem(data)
        return data
      }).filter(item => !!item)

    return this.data
  }

  public async getDataItem(id: string, company: string, refresh = true): Promise<T> {
    if (refresh || !this.dataMap[id]) {
      const itemSnapshot = await this.getCollection(company)
        .doc(id)
        .ref.get()

      if (!itemSnapshot.exists) {
        return null
      }

      const item = itemSnapshot.data() as T
      this.setId(item, itemSnapshot.id)
      this.dataMap[id] = item
    }

    return this.dataMap[id]
  }

  public async update(
    id: string,
    itemToUpdate: any,
    ...collectionParams: any[]
  ): Promise<void> {
    return this.getCollection(...collectionParams)
      .doc(id)
      .update(itemToUpdate)
  }
}
